import { createFileRoute } from '@tanstack/react-router';

import NotFound from '@/ui/pages/NotFound';

/**
 * Catch-all for a URL this app does not serve (HS-1396).
 *
 * It lives **inside** `_dashboard` for two reasons, and both matter:
 *
 * - The navigation rail survives. A user who mistypes one address should not also lose the way to
 *   every address that does work — the same argument `forbidden.tsx` makes for sitting here.
 * - The page stays in a lazy chunk. `__root.tsx` is in the entry graph, so a styled component
 *   reached from there drags its stylesheet into the initial CSS payload, which has ~2.7 kB of
 *   headroom against a budget that may only be lowered (HS-874). `__root` therefore keeps a
 *   minimal, styleless fallback and this route carries the real screen.
 *
 * Being a splat, it is the least specific route in the tree, so every literal and parameterised
 * route still wins — including the `/institutes/*` redirects HS-1212 left for old bookmarks.
 *
 * No permission guard: a page that does not exist is not a page anyone may be refused.
 */
export const Route = createFileRoute('/_dashboard/$')({
  component: NotFound,
});
